/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    setConfig(state, config) {
        state.config = config;
    },
    setZoom(state, zoom) {
        state.config.zoom = zoom;
    },
    setPostalAddress(state, postalAddress) {
        state.postalAddress = postalAddress;
    },
    setLocationResult(state, locations) {
        state.locationsResult = locations;
    },
    setCityRestrictConfig(state, city) {
        state.config.cityRestrictConfig = city;
    },
    setPoisConfig(state, poisConfig) {
        state.config.poisConfig = poisConfig;
    },
    setPois(state, pois) {
        state.pois = pois;
    },
    setCities(state, cities) {
        state.cities = cities;
    },
    setLocation(state, location) {
        state.location = location;
    },
    setCenter(state, center) {
        state.config.center = center;
    },

};
